export default __webpack_public_path__ + "static/media/42k.7da8381c.md";